import { IStatusCodeMessage } from "@/models";
import { IModalKeyEnums, IRolePermissionAccess } from "@/models/permission";

export interface IMobileVerifyOrSendOTPReq {
  phone_number: string;
  country_code: string;
  device_id?: string;
  device_token?: string;
}

export interface IMobileVerifyOrSend {
  OtpId: string;
}

export interface IMobileVerifyOrSendOTPInfo {
  result: IMobileVerifyOrSend;
}

export type IMobileVerifyOrSendOTPRes = IStatusCodeMessage &
  IMobileVerifyOrSendOTPInfo;

export interface IOTPVerifyReq {
  otp_code: string;
  token: string;
  device_id?: string;
  device_token?: string;
}
export interface IFeature {
  featureKey: string;
  permissionAccess: IRolePermissionAccess;
}

export interface IPermission {
  moduleKey: IModalKeyEnums;
  features: IFeature[];
}

export interface IDoctorBasicInfo {
  user_id: string;
  name: string;
}

export interface IOTPVerifyInfo {
  token: string;
  user_id: string;
  role: string;
  language: string;
  name: string;
  clinic_id: string;
  doctor_id: string;
  doctor_name: string;
  permissions: IPermission[];
  country_code: string;
  phone_number: string;
  profile_photo?: string;
  doctorBasicInfo?: IDoctorBasicInfo;
  video_consultaion?: boolean;
  video_consultaion_fee: string;
}
export interface IOTPVerifyDetail {
  result: IOTPVerifyInfo;
}

export type IOTPVerifyRes = IStatusCodeMessage & IOTPVerifyDetail;

export interface IMobileVerify {
  mobileNo: string;
}

export interface IOtpVerify {
  otp: string;
}

export interface IAccessTokenDetail {
  country_code: string;
  phone_number: string;
  user_id: string;
  role: string;
  language: string;
  permissions: IPermission[];
}
export interface IAccessTokenResult {
  result: IAccessTokenDetail;
}

export type IAccessToken = IStatusCodeMessage & IAccessTokenResult;

export enum ILanguageEnums {
  ENG = "eng",
  HIN = "hin",
  GUJ = "guj",
  BEN = "ben",
}

export interface IGuestUserLogin {
  token: string;
  role: string;
}

export interface IGuestUserLoginResult {
  result: IGuestUserLogin;
}
export type IGuestUserLoginResponse = IStatusCodeMessage &
  IGuestUserLoginResult;

export interface IGeoMapAddress {
  house_number: string;
  road: string;
  suburb: string;
  city: string;
  town: string;
  state_district: string;
  state: string;
  "ISO3166-2-lvl4": string;
  postcode: string;
  country: string;
  country_code: string;
}

export interface IGetMapLocationAddress {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  class: string;
  type: string;
  place_rank: number;
  importance: number;
  addresstype: string;
  name: string;
  display_name: string;
  address: IGeoMapAddress;
  boundingbox: string[];
}

export enum IOnboardingSteps {
  LANGUAGE = "LANGUAGE",
  TUTORIAL = "TUTORIAL",
  VERIFY_MOBILE_NUMBER = "VERIFY_MOBILE_NUMBER",
  VERIFY_OTP_NUMBER = "VERIFY_OTP_NUMBER",
}
